import { render } from "./BoardCounselDetail.vue?vue&type=template&id=71fb0bdb"
import script from "./BoardCounselDetail.vue?vue&type=script&lang=js"
export * from "./BoardCounselDetail.vue?vue&type=script&lang=js"

import "./BoardCounselDetail.vue?vue&type=style&index=0&id=71fb0bdb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__